import sanitizeHtml from 'sanitize-html';
import i18n from 'src/features/i18n';
import { isEmpty } from 'src/utils/helper';
import {
  NOTIFICATION_CREATE,
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_INFO,
  NOTIFICATION_TYPE_WARNING,
  NOTIFICATION_TYPE_MESSAGE,
} from 'src/store/modules/notification';

function getTitle(key, title) {
  let tTitle = i18n.t(key);
  if (!isEmpty(title)) {
    tTitle = title;
  }
  return tTitle;
}
const notification = `notification/${NOTIFICATION_CREATE}`;
const toast = {
  success({
    title, msg, duration, temporaryId = null,
  }) {
    const tTitle = getTitle('T_SUCCESS', title);
    window.$store.commit(notification, {
      type: NOTIFICATION_TYPE_SUCCESS,
      title: tTitle,
      body: msg,
      duration,
      temporaryId,
    });
  },
  warning({
    title, msg, duration, temporaryId = null,
  }) {
    const tTitle = getTitle('T_WARNING', title);
    window.$store.commit(notification, {
      type: NOTIFICATION_TYPE_WARNING,
      title: tTitle,
      body: msg,
      duration,
      temporaryId,
    });
  },
  info({
    title, msg, duration, temporaryId = null,
  }) {
    const tTitle = getTitle('T_INFORMATION', title);
    window.$store.commit(notification, {
      type: NOTIFICATION_TYPE_INFO,
      title: tTitle,
      body: msg,
      duration,
      temporaryId,
    });
  },
  error({
    title, msg, duration, temporaryId = null,
  }) {
    const tTitle = getTitle('T_ERROR', title);
    window.$store.commit(notification, {
      type: NOTIFICATION_TYPE_ERROR,
      title: tTitle,
      body: msg,
      duration,
      temporaryId,
    });
  },
  message({
    title, msg, duration, temporaryId = null,
  }) {
    const tTitle = getTitle('T_NEW_MESSAGE', title);
    const sanitizedMsg = sanitizeHtml(msg, {
      allowedTags: null,
    }).replace(/[<>/]/ig, () => ' ').replace(/\s+/g, ' ').trim();
    const trimmedMsg = sanitizedMsg ? sanitizedMsg.substring(0, 140) : '';

    window.$store.commit(notification, {
      type: NOTIFICATION_TYPE_MESSAGE,
      title: tTitle,
      body: trimmedMsg,
      duration,
      temporaryId,
    });
  },
};

window.$toast = toast;

export default toast;
